module.exports = __webpack_public_path__ + "assets/i18n/es.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/es.json
// module id = 1208
// module chunks = 0